import { bindToggleRemote } from '../../smartpak/toggleremote.js';
import searchPage from './searchpage.js';
import { captureItemSelection, monitorPLPItemsInView } from '../../vendor/googletagmanager/spevents/plpeventlisteners.js';

const itemsInViewMonitor = monitorPLPItemsInView();
const handlePageUpdates = () => {
    itemsInViewMonitor.refresh();
    captureItemSelection();
};

searchPage.init(handlePageUpdates);

bindToggleRemote();

